var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c("span", {
      staticClass: "item-icon",
      class: _vm.contract.image,
      attrs: { "aria-label": _vm.contract.offerLabel, "aria-hidden": "true" },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "item-container" }, [
      _c("div", { staticClass: "item-text" }, [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.contract.offerLabel) },
        }),
        _vm._v(" "),
        _c("small", {
          staticClass: "item-desc",
          domProps: { innerHTML: _vm._s(_vm.phoneNumber) },
        }),
      ]),
      _vm._v(" "),
      _vm.contract.rerouting && _vm.contract.enabled
        ? _c("div", { staticClass: "ob1-tooltip" }, [
            _c("span", {
              staticClass: "ob1-tooltip-trigger item-status icon-info",
              attrs: {
                "aria-describedby": "tooltip-item-status-" + _vm.contract.id,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "ob1-tooltip-content ob1-tooltip-right",
                attrs: { id: "tooltip-item-status-" + _vm.contract.id },
              },
              [
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.contract.rerouting.messageDescription
                    ),
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "ob1-tooltip-shadow" }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }